import { Component, effect, Input, Output, WritableSignal,EventEmitter } from "@angular/core";
import { ColumnList } from "../../models/column-preference";

@Component({
    selector: "app-column-settings",
    templateUrl: "./column-settings.component.html",
    styleUrl: "./column-settings.component.scss",
    standalone: false
})
export class ColumnSettingsComponent {
  @Input({ required: true }) sourceColumnList!: WritableSignal<ColumnList[] | [] >;
  @Input({ required: true }) targetColumnList!: WritableSignal< ColumnList[] | [] >;

  @Output() OnListUpdation = new EventEmitter<{
    source: ColumnList[] | [],
    target: ColumnList[] | []
  }>();

  constructor() {
    // Keep the sequence numbers in sync whenever the source/target signals are
    // (re)assigned, e.g. on initial input binding. In-place reorders triggered by
    // the PickList are handled by the explicit updateOrder() calls on its events.
    effect(() => {
      this.sourceColumnList();
      this.targetColumnList();
      this.updateOrder();
    });
  }

  /**
 * Emits an update event with the current state of source and target lists.
 */
  emitListUpdate() {
    this.OnListUpdation.emit({
      source: this.sourceColumnList(),
      target: this.targetColumnList(),
    });
  }

  /**
   * Assigns a sequential, 1-based `order` to every column in both the source and
   * target lists based on its current position.
   *
   * The `order` value is used to render the sequence badge directly in the
   * template. Binding the persisted `order` (instead of the PickList item
   * template index) keeps the sequence numbers stable while filtering, because
   * PrimeNG's PickList exposes the index of the item within the filtered view.
   */
  updateOrder(): void {
    this.sourceColumnList().forEach((col, index) => {
      col.order = index + 1;
    });
    this.targetColumnList().forEach((col, index) => {
      col.order = index + 1;
    });
  }
}
